/** Bounded insertion-order memo: revisited ground cells avoid scanning the world graph. */
export class PresentationCache<T> {
  private values = new Map<string, T>();
  constructor(private readonly capacity = 16384) {}
  get size(): number { return this.values.size; }
  clear(): void { this.values.clear(); }
  getOrCreate(key: string, create: () => T): T {
    const value = this.values.get(key);
    if (value !== undefined || this.values.has(key)) return value as T;
    const next = create();
    if (this.values.size >= this.capacity) {
      const oldest = this.values.keys().next().value;
      if (oldest !== undefined) this.values.delete(oldest);
    }
    this.values.set(key, next);
    return next;
  }
}

/** Full rendered extent bounds every side because valid contact anchors stay inside the texture. */
export function propCandidateIntersectsViewport(x: number, y: number, extent: number,
  minX: number, maxX: number, minY: number, maxY: number): boolean {
  return x + extent >= minX && x - extent <= maxX && y + extent >= minY && y - extent <= maxY;
}
